import { CountUp } from 'countup.js';

const $countupValueEls = document.querySelectorAll('.js-countup');

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.intersectionRatio > 0) {
      const $target = entry.target;

      // The count-up animation
      $target.textContent = $target.dataset.value;
      const value = $target.textContent;

      const options = {
        decimalPlaces: $target.dataset.decimalplaces || '',
        decimal: $target.dataset.decimal || '',
        duration: $target.dataset.duration || '',
        separator: $target.dataset.separator || '',
        useGrouping: true,
      };

      const countUp = new CountUp($target, value, options);
      countUp.start();

      // observer.unobserve($target);
    }
  });
});

$countupValueEls.forEach(($countupValueEl) => {
  observer.observe($countupValueEl);
});
